import { useQuery } from "@tanstack/react-query";
import { tadbir } from "../services/api";
import { StaticFundContent } from "../data/publicStaticFunds";

export interface TadbirFundNav {
  seoRegisterNo: string | null;
  date: string;
  localDate: string | null;
  cancelNav: number;
  subscriptionNav: number;
  statisticNav: number;
  totalNetAssetValue: number;
  totalUnit: number;
  totalInvestor: number;
  totalCancelUnit: number;
  totalSubscriptionUnit: number;
  groupId: number;
  groupName: string | null;
}

export interface TadbirFund {
  fundRegisterCode: string;
  fundName: string;
  fundSummaryName?: string;
  minimumCapitalUnit: number;
  liquidityGurantor1: string;
  liquidityGurantor2: string | null;
  guaranteeRate: number;
  marketMaker: string | null;
  profitGurantor: string;
  dailyReturn: number;
  weeklyReturn: number;
  monthlyReturn: number;
  overallReturn: number;
  quarterReturn: number;
  annualReturn: number;
  profitPeriod: number;
  maximumCapitalUnit: number;
  issuanceWage: number;
  redemtionWage: number;
  semiYearly: number;
  profitDay: number;
  fundTypeTitle: string;
  managerName: string;
  investmentManager: string;
  auditor: string;
  custodian: string;
  registrationManager: string;
  publishDate: string;
  remainedUnit: number;
  startDate: string;
  nav: TadbirFundNav;
  wageSettings: Array<{ name: string; value: string; description: string }>;
  navAdjustSetting: Array<{ splitRate: number; rateDate: string }>;
  websiteAddress: string;
  staticContent?: StaticFundContent;
}

export interface TadbirFundsResponse {
  items: TadbirFund[];
  pageNumber: number;
  pageSize: number;
  totalPageCount: number;
  totalItemCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  isFirstPage: boolean;
  isLastPage: boolean;
  firstItemOnPage: number;
  lastItemOnPage: number;
}

export const useFunds = () =>
  useQuery(
    ["omidibFunds"],
    async () => {
      const response = await tadbir.getFunds();
      return response.funds as TadbirFundsResponse;
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
